import type { WarehouseGoodsItem } from '../types/warehouseGoodsCatalog';

/**
 * CUKCUK does not currently have master-item codes for these 8am
 * semi-finished ingredients.  They are kept separate from the official
 * catalogue so a normal export never invents a code silently.  The optional
 * draft export can opt in after importing the companion material-master file.
 */
export const CUKCUK_DRAFT_MATERIAL_MAPPINGS: WarehouseGoodsItem[] = [
  {
    productCode: '8AM-COLD-BREW-ETHIOPIA',
    name: 'Cold brew Ethiopia G1',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-COLD-BREW-ETHIOPIA',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-COLD-BREW-KENYA',
    name: 'Cold brew Kenya AA',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-COLD-BREW-KENYA',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-COLD-BREW',
    name: 'Cold brew',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-COLD-BREW',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-CASCARA',
    name: 'Cascara',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-CASCARA',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-COT-CHANH',
    name: 'Cốt chanh',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-COT-CHANH',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-KEM-MAN',
    name: 'Kem mặn',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-KEM-MAN',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-SINGLE-SHOT-A',
    name: 'Single shot A/Double shot A',
    group: 'Nguyên vật liệu',
    baseUnit: 'G',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-SINGLE-SHOT-A',
    cukcukUnit: 'G',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
  {
    productCode: '8AM-BROWNIE',
    name: 'Bánh Brownie',
    group: 'Nguyên vật liệu',
    baseUnit: 'Cái',
    gramsPerBaseUnit: 1,
    cukcukMaterialCode: '8AM-BROWNIE',
    cukcukUnit: 'Cái',
    supplierId: 'NCC003',
    supplierName: 'Shopee',
  },
];

export const mergeCukcukDraftMaterials = (
  materials: WarehouseGoodsItem[],
): WarehouseGoodsItem[] => {
  const existingCodes = new Set(
    materials
      .flatMap((material) => [material.productCode, material.cukcukMaterialCode])
      .filter(Boolean)
      .map((code) => String(code).trim().toLowerCase()),
  );
  return [
    ...materials,
    ...CUKCUK_DRAFT_MATERIAL_MAPPINGS.filter((material) =>
      !existingCodes.has(String(material.cukcukMaterialCode).trim().toLowerCase()),
    ),
  ];
};
